// extracted by mini-css-extract-plugin
export default {"widthConstrain":"header_widthconstrain_widthConstrain","wideWithConstrain":"header_widthconstrain_wideWithConstrain"};